export const IsNotValue = [
  null,
  "null",
  undefined,
  "undefined",
  "+undefined",
  "",
  "<p></p>\n",
  "Invalid Date",
  "Invalid date"
];

export const occupationType = [
  { value: 1, label: "Business Owner" },
  { value: 2, label: "Self Employed" }
];

export const statusList = [
  { value: 0, label: "Waiting For Welcome Kit" },
  { value: 2, label: "Ready to Ship" },
  { value: 1, label: "Courier Delivered" },
  { value: 4, label: "Incorrect Address" }
];

export const gender = [
  { label: "Male", value: 1 },
  { label: "Female", value: 2 }
];
